import { savings } from './savings-config/CZ';
import { loan } from './loan-config/CZ';
import { transactions } from './history-config/CZ';
import { statements } from './statements-config/CZ';

export const buildingSociety = {
    transactions,
    statements,
    overview: {
        enabled: true,
        list: {
            jointContractHoldersDisplay: true,
        },
    },
    loan,
    savings,
    isNativeAliasChangeAllowed: true,
};
